import {startOfWeek, addDays, subWeeks, isWithinInterval} from 'date-fns';

type UtilizationBucket = {
  week: string;
  start: Date;
  end: Date;
  total: number;
  billable: number;
};

export const calculateUtilization = (
  sessions: any[],
): {
  week: string;
  percentage: number;
  total: number;
  billable: number;
}[] => {
  const now = new Date();
  const weeks: UtilizationBucket[] = [];

  for (let i = 11; i >= 0; i--) {
    const start = startOfWeek(subWeeks(now, i), {weekStartsOn: 0});
    const end = addDays(start, 7);
    weeks.push({
      week: start.toISOString().split('T')[0],
      start,
      end,
      total: 0,
      billable: 0,
    });
  }

  for (const session of sessions) {
    const {editedStartTimestamp, editedEndTimestamp, cpt} = session;
    const start = new Date(editedStartTimestamp);
    const end = new Date(editedEndTimestamp);
    const durationHours = (end.getTime() - start.getTime()) / 3600000;

    if (durationHours <= 0 || durationHours < 0.0833) {
      continue;
    }

    for (const week of weeks) {
      if (isWithinInterval(start, {start: week.start, end: week.end})) {
        week.total += durationHours;

        if (cpt?.length && !cpt.includes('00000')) {
          week.billable += durationHours;
        }

        break;
      }
    }
  }

  return weeks.map(({week, total, billable}) => {
    const percentage = total > 0 ? (billable / total) * 100 : 0;
    return {
      week,
      percentage: Math.abs(percentage) < 0.01 ? 0 : percentage,
      total: Math.abs(total) < 0.01 ? 0 : total,
      billable: Math.abs(billable) < 0.01 ? 0 : billable,
    };
  });
};
